import { CashRequestMiddleware } from './types'

export const webContextRequest: CashRequestMiddleware = request => {
  const win = typeof window !== 'undefined' ? window : { context: undefined }
  const context = win.context != null && win.context !== '' ? win.context : 'DEFAULT'

  const headers = request.headers as Record<string, string>
  headers['x-web-context'] = context

  return request
}
